// extracted by mini-css-extract-plugin
module.exports = {"constituencyScope":"constituency_constituencyScope__Vh1zg"};